interface CarouselItem {
  title: string;
  desc: string;
  tag: string;
  img: string;
  imgAlt: string;
}

const carouselItems: CarouselItem[] = [
  {
    title: '暑期档·古装大剧专题',
    desc: '庆余年、长相思、墨雨云间等年度热门古装剧集一网打尽，从权谋到仙侠、从悬疑到爱情，满足你的所有古装口味。',
    tag: '重磅专题',
    img: 'https://readdy.ai/api/search-image?query=Grand%20ancient%20Chinese%20palace%20architecture%20with%20flowing%20silk%20banners%2C%20warm%20golden%20sunset%20lighting%2C%20traditional%20Chinese%20aesthetic%2C%20cinematic%20wide%20shot%2C%20epic%20historical%20drama%20atmosphere%2C%20rich%20warm%20orange%20and%20gold%20tones&width=1200&height=600&seq=juzi-carousel-01&orientation=landscape',
    imgAlt: '古装大剧专题',
  },
  {
    title: '国漫崛起·热门番剧合集',
    desc: '斗破苍穹、完美世界、凡人修仙传等国漫力作持续更新，精美画质与燃情剧情，带你感受国产动画的无限魅力。',
    tag: '国漫精选',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20art%20style%20epic%20battle%20scene%20with%20warriors%20and%20magical%20energy%20effects%2C%20vibrant%20colors%2C%20dynamic%20composition%2C%20fantasy%20landscape%20background%2C%20modern%20donghua%20aesthetic%2C%20warm%20glowing%20energy&width=1200&height=600&seq=juzi-carousel-02&orientation=landscape',
    imgAlt: '国漫崛起专题',
  },
  {
    title: '高分电影·院线大片专区',
    desc: '汇集国内外高分电影资源，从好莱坞大片到华语佳作，蓝光画质呈现，让你在家也能享受影院级观影体验。',
    tag: '电影专区',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20theater%20interior%20with%20warm%20ambient%20lighting%2C%20red%20velvet%20seats%2C%20large%20screen%20displaying%20abstract%20colorful%20imagery%2C%20luxurious%20atmosphere%2C%20film%20projector%20light%20beam%2C%20golden%20honey%20tones&width=1200&height=600&seq=juzi-carousel-03&orientation=landscape',
    imgAlt: '高分电影专区',
  },
  {
    title: '纪录片精选·探索未知世界',
    desc: '从深海到宇宙，从历史到科技，精选全球顶级纪录片，超高清画质带你领略世界的壮丽与奇妙。',
    tag: '纪录精选',
    img: 'https://readdy.ai/api/search-image?query=Stunning%20aerial%20landscape%20of%20mountains%20and%20valleys%20at%20golden%20hour%2C%20dramatic%20clouds%2C%20warm%20sunlight%2C%20nature%20documentary%20style%20photography%2C%20breathtaking%20vista%2C%20rich%20earth%20tones%20and%20golden%20light&width=1200&height=600&seq=juzi-carousel-04&orientation=landscape',
    imgAlt: '纪录片精选专题',
  },
  {
    title: '综艺娱乐·欢笑不断线',
    desc: '热门综艺最新季全集收录，从户外真人秀到棚内脱口秀，让你在忙碌生活中找到放松的快乐时光。',
    tag: '综艺合集',
    img: 'https://readdy.ai/api/search-image?query=Bright%20colorful%20TV%20studio%20set%20with%20warm%20stage%20lighting%2C%20variety%20show%20atmosphere%2C%20cheerful%20vibrant%20colors%2C%20entertainment%20program%20set%20design%2C%20modern%20studio%20production%2C%20golden%20and%20coral%20warm%20tones&width=1200&height=600&seq=juzi-carousel-05&orientation=landscape',
    imgAlt: '综艺娱乐专题',
  },
  {
    title: '短剧专区·轻松追剧不费时',
    desc: '精选热门微短剧，每集5-15分钟，节奏紧凑剧情精彩。通勤路上、午休间隙的最佳追剧选择。',
    tag: '短剧精选',
    img: 'https://readdy.ai/api/search-image?query=Modern%20smartphone%20on%20a%20cozy%20desk%20displaying%20video%20content%2C%20warm%20ambient%20lighting%20from%20a%20desk%20lamp%2C%20comfortable%20evening%20atmosphere%2C%20minimalist%20setup%2C%20soft%20golden%20light%2C%20relaxed%20viewing%20experience&width=1200&height=600&seq=juzi-carousel-06&orientation=landscape',
    imgAlt: '短剧专区专题',
  },
];

export default function Carousel() {
  return (
    <section id="carousel" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-semibold rounded-full uppercase tracking-wide">
            焦点专题
          </span>
          <h2 className="mt-4 text-2xl md:text-3xl font-bold text-foreground-950">热门专题 · 一站尽览</h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base">
            六大精选专题，覆盖最热门的内容类型，快速找到你的观影方向。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselItems.map((item) => (
            <article key={item.title} className="group cursor-pointer bg-background-100 rounded-2xl overflow-hidden border border-background-200/60 hover:border-primary-300/40 transition-all duration-200">
              <div className="relative h-48 md:h-52 overflow-hidden">
                <img
                  src={item.img}
                  alt={item.imgAlt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="bg-accent-500 text-background-50 text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-bold text-foreground-950 mb-2">{item.title}</h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}